<template>
    <nav class="settings__nav">
        <div class="settings__nav-item" :class="{ active: step === v.step }" v-for="(v, i) in menus" :key="i" @click="$emit('on-change-step', v.step)">
            <span class="settings__nav-item-text">{{ getTranslatedText(v.title) }}</span>
        </div>
    </nav>
</template>
<script>
import languageMixins from '@/mixins/language/language-mixins'

export default {
    mixins: [languageMixins],
    props: {
        step: {
            type: Number,
            default: 1,
        },
    },
    data() {
        return {
            menus: [
                {
                    title: 'reset pin',
                    step: 1,
                },
                {
                    title: 'print',
                    step: 2,
                },
                {
                    title: 'version',
                    step: 3,
                },
            ],
        }
    },
}
</script>
<style lang="scss">
@import '~ThemePath/scss/settings/_nav.scss';
</style>
